module.exports = __webpack_public_path__ + "img/order.814c8e6f.svg";